module.exports = __webpack_public_path__ + "img/gallery5.2da9bae.jpg";